/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DecksInputs */



/**
* | output |
* | --- |
* | "Decks" |
*
* @param {Nav_DecksInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_decks = /** @type {((inputs?: Nav_DecksInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DecksInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Decks")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decks")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡组")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("牌組")
	if (locale === "ko") return /** @type {LocalizedString} */ ("덱")
	return /** @type {LocalizedString} */ ("Decks")
});